module.exports = __webpack_public_path__ + "img/ic-arrow-e-inactive.b07f7bfb.svg";